import { trigger, state, style, transition, animate, animateChild, query } from '@angular/animations';

export const onSideNavChange = trigger('onSideNavChange', [
  state('close',
    style({
      'width': '96px'
    })
  ),
  state('open',
    style({
      'width': '260px'
    })
  ),
  transition('close => open', animate('250ms ease-in-out')),
  transition('open => close', animate('250ms ease-in-out')),
]);


export const onMainContentChange = trigger('onMainContentChange', [
  state('close',
    style([{
      'margin-left': '96px'
    }])
  ),
  state('open',
    style({
      'margin-left': '260px'
    })
  ),
  state('mobile',
    style({
      'margin-left': '0'
    })
  ),
  transition('close => open', animate('250ms ease-in-out')),
  transition('open => close', animate('250ms ease-in-out')),
]);

export const animateText = trigger('animateText', [
  state('hide',
    style({
      'display': 'none',
      // opacity: 0,
    })
  ),
  state('show',
    style({
      //'display': 'block',
      opacity: 1,
    })
  ),
  transition('hide => show', animate('200ms ease-in-out')),
  transition('show => hide', animate('200ms ease-in-out')),
]);
/*
// xs --- Extra small devices (portrait phones, less than 576px)
// No media query since this is the default in Bootstrap

// sm --- Small devices (landscape phones, 576px and up)
@media (min-width: 576px) { ... }

// md --- Medium devices (tablets, 768px and up)
@media (min-width: 768px) { ... }

// lg --- Large devices (desktops, 992px and up)
@media (min-width: 992px) { ... }

// xl --- Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) { ... }
 */
